import { CHANGE_INPUT } from "../actions/actionTypes.js";

const initialState = {
  rivers: {
    dnipro: {
      амоній: [
        { time: "20/01/15", pv: 0.23 },
        { time: "20/02/15", pv: 0.13 },
        { time: "20/03/15", pv: 0.24 },
        { time: "20/04/15", pv: 0.28 },
        { time: "20/05/15", pv: 0.42 },
        { time: "20/06/15", pv: 0.46 },
        { time: "20/07/15", pv: 0.53 },
        { time: "20/08/15", pv: 0.31 },
        { time: "20/09/15", pv: 0.38 },
        { time: "20/10/15", pv: 0.24 },
        { time: "20/11/15", pv: 0.18 },
        { time: "20/12/15", pv: 0.27 },
      ],
      БСК5: [
        { time: "20/04/15", pv: 1400 },
        { time: "20/04/15", pv: 2398 },
        { time: "20/04/15", pv: 5800 },
        { time: "20/04/15", pv: 3908 },
        { time: "20/04/15", pv: 7800 },
        { time: "20/04/15", pv: 2800 },
        { time: "20/04/15", pv: 6300 },
      ],
      фосфат: [
        { time: "20/04/15", pv: 2400 },
        { time: "20/04/15", pv: 1398 },
        { time: "20/04/15", pv: 9800 },
        { time: "20/04/15", pv: 3908 },
        { time: "20/04/15", pv: 4800 },
        { time: "20/04/15", pv: 3800 },
        { time: "20/04/15", pv: 4300 },
      ],
      хлорид: [
        { time: "20/04/15", pv: 2400 },
        { time: "20/04/15", pv: 1398 },
        { time: "20/04/15", pv: 9800 },
        { time: "20/04/15", pv: 3908 },
        { time: "20/04/15", pv: 4800 },
        { time: "20/04/15", pv: 3800 },
        { time: "20/04/15", pv: 4300 },
      ],
      ХСК: [
        { time: "20/04/15", pv: 2400 },
        { time: "20/04/15", pv: 1398 },
        { time: "20/04/15", pv: 9800 },
        { time: "20/04/15", pv: 3908 },
        { time: "20/04/15", pv: 4800 },
        { time: "20/04/15", pv: 3800 },
        { time: "20/04/15", pv: 4300 },
      ],
      кисень: [
        { time: "20/04/15", pv: 2400 },
        { time: "20/04/15", pv: 1398 },
        { time: "20/04/15", pv: 9800 },
        { time: "20/04/15", pv: 3908 },
        { time: "20/04/15", pv: 4800 },
        { time: "20/04/15", pv: 3800 },
        { time: "20/04/15", pv: 4300 },
      ],
      нітрат: [
        { time: "20/04/15", pv: 2400 },
        { time: "20/04/15", pv: 1398 },
        { time: "20/04/15", pv: 9800 },
        { time: "20/04/15", pv: 3908 },
        { time: "20/04/15", pv: 4800 },
        { time: "20/04/15", pv: 3800 },
        { time: "20/04/15", pv: 4300 },
      ],
      нітрит: [
        { time: "20/04/15", pv: 2400 },
        { time: "20/04/15", pv: 1398 },
        { time: "20/04/15", pv: 9800 },
        { time: "20/04/15", pv: 3908 },
        { time: "20/04/15", pv: 4800 },
        { time: "20/04/15", pv: 3800 },
        { time: "20/04/15", pv: 4300 },
      ],
      перманганат: [
        { time: "20/04/15", pv: 2400 },
        { time: "20/04/15", pv: 1398 },
        { time: "20/04/15", pv: 9800 },
        { time: "20/04/15", pv: 3908 },
        { time: "20/04/15", pv: 4800 },
        { time: "20/04/15", pv: 3800 },
        { time: "20/04/15", pv: 4300 },
      ],
      сульфат: [
        { time: "20/04/15", pv: 2400 },
        { time: "20/04/15", pv: 1398 },
        { time: "20/04/15", pv: 9800 },
        { time: "20/04/15", pv: 3908 },
        { time: "20/04/15", pv: 4800 },
        { time: "20/04/15", pv: 3800 },
        { time: "20/04/15", pv: 4300 },
      ],
      "завислі речовини": [
        { time: "20/04/15", pv: 2400 },
        { time: "20/04/15", pv: 1398 },
        { time: "20/04/15", pv: 9800 },
        { time: "20/04/15", pv: 3908 },
        { time: "20/04/15", pv: 4800 },
        { time: "20/04/15", pv: 3800 },
        { time: "20/04/15", pv: 4300 },
      ],
    },
  },
  chemicals: {
    амоній: 0.5,
    БСК5: 4.0,
    фосфат: 3.5,
    хлорид: 300.0,
    ХСК: 5.0,
    кисень: 4.0,
    нітрат: 40.0,
    нітрит: 0.08,
    перманганат: 5.0,
    сульфат: 250.0,
    "завислі речовини": 15.0,
  },
};

export default function pollutantsReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_INPUT:
      return { ...state };
    default:
      return state;
  }
}
